export const isStringArray = (array: unknown): array is string[] => {
  return Array.isArray(array) && array.every((item) => typeof item === "string");
};

/**
 * Compares two arrays for equality by creating sorted copies to avoid mutation
 * @param a - First array to compare
 * @param b - Second array to compare
 * @returns True if arrays contain the same elements (order independent)
 */
export const arraysEqual = (a: string[], b: string[]): boolean => {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort((a, b) => a.localeCompare(b));
  const sortedB = [...b].sort((a, b) => a.localeCompare(b));
  return sortedA.every((val, index) => val === sortedB[index]);
};

declare global {
  interface ArrayConstructor {
    isArray(arg: unknown): arg is ReadonlyArray<unknown> | Array<unknown>;
  }
}
